// https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/643
// image F2 if 30-15 then background set to white

export default function RemoveBakgroundForLiveScore() {
  // in html string find row-first and row-second class

  const liveTennis = document.querySelectorAll(".live-tennis");

  liveTennis.forEach((element) => {
    const firstRow = element.querySelector(".row-first");
    const secondRow = element.querySelector(".row-second");

    const firstRowChildren = firstRow.children;
    const secondRowChildren = secondRow.children;

    for (let i = 0; i < firstRowChildren.length; i++) {
      const firstRowChild = firstRowChildren[i];
      const secondRowChild = secondRowChildren[i];

      const firstRowChildScore = +firstRowChild.getAttribute("data-score");
      const secondRowChildScore = +secondRowChild.getAttribute("data-score");

      if (firstRowChildScore === 30 && secondRowChildScore === 15) {
        firstRowChild.classList.remove("live-score");
        secondRowChild.classList.remove("live-score");
      }
    }
  });
}
